import React, { useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeftIcon, BoxesIcon, LockIcon, PencilIcon, PlusIcon, Trash2Icon } from 'lucide-react';
import { EncabezadoPagina } from '../components/layout/AppLayout';
import { Campo, EncabezadoPanel, EstadoVacio, Panel } from '../components/ui/Basicos';
import { EditorSucursal } from '../components/almacenes/EditorSucursal';
import { MapaAlmacen } from '../components/almacenes/MapaAlmacen';
import { useDatos } from '../contexts/DatosContext';
import { abogadoPorId } from '../data/abogados';
import { crearAlmacen } from '../data/almacenesConfig';
import { contarCajas, expedientesEnAlmacen, mapaDeAlmacenes } from '../utils/almacen';
const claseInput = 'h-9 w-full rounded border border-gris-200 px-3 text-sm text-gris-800 placeholder:text-gris-400 focus:border-marino-500';
const claseEtiqueta = 'block text-2xs font-semibold uppercase tracking-wide text-gris-500';
const claseBotonPie = 'inline-flex h-8 w-full items-center justify-center gap-1.5 rounded border border-gris-200 text-2xs font-semibold text-marino-700 transition-colors duration-150 hover:border-marino-300 hover:bg-marino-50';
export function ConfigSucursalDetalle() {
  const {
    id = ''
  } = useParams();
  const {
    rol,
    sucursales,
    almacenes,
    expedientes,
    actualizarSucursal,
    agregarAlmacen,
    eliminarAlmacen,
    agregarPasillo,
    agregarEstante,
    agregarCaja
  } = useDatos();
  const [editandoDatos, setEditandoDatos] = useState(false);
  const [creando, setCreando] = useState(false);
  const [nombre, setNombre] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [pasillos, setPasillos] = useState(3);
  const [estantesPorPasillo, setEstantesPorPasillo] = useState(4);
  const [cajasPorEstante, setCajasPorEstante] = useState(12);
  const [capacidad, setCapacidad] = useState(6);
  const [error, setError] = useState('');
  const sucursal = sucursales.find(s => s.id === id);
  const susAlmacenes = almacenes.filter(a => a.sucursalId === id);
  const mapa = useMemo(() => mapaDeAlmacenes(almacenes, expedientes, id), [almacenes, expedientes, id]);
  if (rol !== 'Administrador') {
    return <Panel data-id="element-1227" data-mp="2unr4saig6tks">
        <div className="flex flex-col items-center gap-3 px-6 py-14 text-center" data-id="element-1228" data-mp="2um6eix361wsq">
          <LockIcon className="h-6 w-6 text-gris-300" aria-hidden="true" data-id="element-1229" data-mp="2zlaovr1tu0kn" />
          <p className="text-sm font-semibold text-gris-700" data-id="element-1230" data-mp="2lmj8fxzhs2tc">Módulo restringido</p>
        </div>
      </Panel>;
  }
  if (!sucursal) {
    return <Panel data-id="element-1231" data-mp="2ppfvc0w2el33">
        <EstadoVacio mensaje="No encontramos esa sucursal" sugerencia="Vuelve al listado de sucursales." data-id="element-1232" data-mp="2pls4xalx2esl" />
      </Panel>;
  }
  const responsable = abogadoPorId(sucursal.responsableId);
  const crear = () => {
    if (!nombre.trim()) {
      setError('Captura el nombre o clave del almacén (ej. Almacén C).');
      return;
    }
    agregarAlmacen(crearAlmacen({
      id: `alm-${sucursal.id}-${Date.now()}`,
      sucursalId: sucursal.id,
      nombre: nombre.trim(),
      descripcion: descripcion.trim() || 'Sin descripción de ubicación.',
      pasillos,
      estantesPorPasillo,
      cajasPorEstante,
      capacidad
    }));
    setNombre('');
    setDescripcion('');
    setError('');
    setCreando(false);
  };
  return <>
      <EncabezadoPagina titulo={`${sucursal.nombre} · ${sucursal.clave}`} descripcion={`${sucursal.direccion} · ${sucursal.ciudad}, ${sucursal.estado}`} acciones={<>
            <Link to="/configuracion/sucursales" className="inline-flex h-9 items-center gap-2 rounded border border-gris-200 bg-white px-3 text-sm font-medium text-gris-600 transition-colors duration-150 hover:border-gris-300" data-id="element-1234" data-mp="2d7n0s9gshemq">
              <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-1235" data-mp="xp21280ofdpw" />
              Sucursales
            </Link>
            <button type="button" onClick={() => setEditandoDatos(v => !v)} className="inline-flex h-9 items-center gap-2 rounded border border-gris-200 bg-white px-3 text-sm font-medium text-marino-700 transition-colors duration-150 hover:border-marino-300 hover:bg-marino-50" data-id="element-1236" data-mp="sr9xuhul056e">
              <PencilIcon className="h-4 w-4" aria-hidden="true" data-id="element-1237" data-mp="3txe2db66iter" />
              Editar datos
            </button>
            <button type="button" onClick={() => setCreando(v => !v)} className="inline-flex h-9 items-center gap-2 rounded bg-marino-800 px-3.5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-marino-700" data-id="element-1238" data-mp="2x86gg21neiab">
              <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-1239" data-mp="3azbkrhfynyqz" />
              Agregar almacén
            </button>
          </>} data-id="element-1233" data-mp="24avy3e7qf1j6" />

      <Panel data-id="element-1240" data-mp="2egdxz1k7gfgu">
        {editandoDatos ? <EditorSucursal sucursal={sucursal} esNueva={false} clavesUsadas={sucursales.filter(s => s.id !== sucursal.id).map(s => s.clave)} onGuardar={s => {
        actualizarSucursal(s);
        setEditandoDatos(false);
      }} onCancelar={() => setEditandoDatos(false)} data-id="element-1241" data-mp="2iih9fq6vjk24" /> : <dl className="grid gap-x-6 gap-y-4 px-5 py-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-1242" data-mp="2204iixeune0o">
            <Campo etiqueta="Clave del localizador" valor={sucursal.clave} mono data-id="element-1243" data-mp="1x1b514zkbn0i" />
            <Campo etiqueta="Ciudad y estado" valor={`${sucursal.ciudad}, ${sucursal.estado}`} data-id="element-1244" data-mp="1s1op2nscnso0" />
            <Campo etiqueta="Teléfono" valor={sucursal.telefono || 'Sin registrar'} data-id="element-1245" data-mp="1n7ubm23c89xd" />
            <Campo etiqueta="Responsable" valor={responsable?.nombre ?? 'Sin asignar'} data-id="element-1246" data-mp="1ib3vjerj9eby" />
            <Campo etiqueta="Almacenes" valor={String(susAlmacenes.length)} data-id="element-1247" data-mp="1e9qoj1cpf53g" />
            <Campo etiqueta="Cajas configuradas" valor={String(susAlmacenes.reduce((t, a) => t + contarCajas(a), 0))} data-id="element-1248" data-mp="199coa5hcgzfz" />
            <Campo etiqueta="Expedientes resguardados" valor={String(expedientes.filter(e => e.sucursalId === sucursal.id).length)} data-id="element-1249" data-mp="14cmc3t8nunzu" />
            <Campo etiqueta="Estado" valor={sucursal.activa ? 'Activa' : 'Inactiva'} data-id="element-1250" data-mp="zmrz1bxeqkrd" />
          </dl>}
      </Panel>

      {creando && <Panel className="mt-4" data-id="element-1251" data-mp="pnufyoir3jfr">
          <EncabezadoPanel titulo="Nuevo almacén" descripcion="Define la estructura interna de una vez; después puedes agregar pasillos, estantes o cajas uno por uno." data-id="element-1252" data-mp="pn179i08ejuz" />
          <div className="grid gap-4 px-5 py-5 md:grid-cols-3 lg:grid-cols-6" data-id="element-1253" data-mp="1ibgidtg8si11">
            <label className="lg:col-span-2" data-id="element-1254" data-mp="13o58dvzpl631">
              <span className={claseEtiqueta} data-id="element-1255" data-mp="13nbw6fhzdodi">Nombre / clave *</span>
              <input className={`mt-1.5 ${claseInput}`} value={nombre} onChange={e => setNombre(e.target.value)} placeholder="Ej. Almacén C" data-id="element-1256" data-mp="18ln60q89zyvq" />
            </label>
            <label className="md:col-span-2 lg:col-span-4" data-id="element-1257" data-mp="2152jl7lkoviv">
              <span className={claseEtiqueta} data-id="element-1258" data-mp="3lsd475cwk78r">Descripción / ubicación en la sucursal</span>
              <input className={`mt-1.5 ${claseInput}`} value={descripcion} onChange={e => setDescripcion(e.target.value)} placeholder="Ej. Planta alta, cuarto de archivo junto a la sala de juntas" data-id="element-1259" data-mp="3gta6y735z5bc" />
            </label>
            {[{
          etiqueta: 'Pasillos',
          valor: pasillos,
          set: setPasillos,
          max: 12
        }, {
          etiqueta: 'Estantes por pasillo',
          valor: estantesPorPasillo,
          set: setEstantesPorPasillo,
          max: 8
        }, {
          etiqueta: 'Cajas por estante',
          valor: cajasPorEstante,
          set: setCajasPorEstante,
          max: 30
        }, {
          etiqueta: 'Capacidad por caja',
          valor: capacidad,
          set: setCapacidad,
          max: 40
        }].map(campo => <label key={campo.etiqueta} data-id="element-1260" data-mp="2gn6i5vcp6xfo">
                <span className={claseEtiqueta} data-id="element-1261" data-mp="2gkafjtpwnkkw">{campo.etiqueta}</span>
                <input type="number" min={1} max={campo.max} value={campo.valor} onChange={e => campo.set(Math.max(1, Number(e.target.value)))} className={`tabular mt-1.5 ${claseInput}`} data-id="element-1262" data-mp="2llq0lls31r3a" />
              </label>)}
            <p className="tabular self-end text-2xs text-gris-500 lg:col-span-2" data-id="element-1263" data-mp="34bfwkc7l0iws">
              Se crearán{' '}
              <span className="font-semibold text-gris-700" data-id="element-1264" data-mp="39aj2dyvdyt5t">
                {pasillos * estantesPorPasillo * cajasPorEstante}
              </span>{' '}
              cajas con capacidad total de{' '}
              {pasillos * estantesPorPasillo * cajasPorEstante * capacidad} expedientes.
            </p>
          </div>
          {error && <p role="alert" className="px-5 pb-3 text-xs font-medium text-peligro-600" data-id="element-1265" data-mp="1jw4grnfnzmej">
              {error}
            </p>}
          <div className="flex justify-end gap-2 border-t border-gris-200 px-5 py-3" data-id="element-1266" data-mp="3sfnw9my9eami">
            <button type="button" onClick={() => setCreando(false)} className="h-9 rounded border border-gris-200 px-3 text-sm font-medium text-gris-600 transition-colors duration-150 hover:border-gris-300" data-id="element-1267" data-mp="3odtx5j3ppeog">
              Cancelar
            </button>
            <button type="button" onClick={crear} className="h-9 rounded bg-marino-800 px-3.5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-marino-700" data-id="element-1268" data-mp="fy0qdvz6nhkl">
              Crear almacén
            </button>
          </div>
        </Panel>}

      <Panel className="mt-4" data-id="element-1269" data-mp="2vpew60hf0ww4">
        <EncabezadoPanel titulo="Almacenes de la sucursal" descripcion={`${susAlmacenes.length} almacenes · estructura Pasillo → Estante → Caja`} data-id="element-1270" data-mp="2vqpydvv7pwl4" />
        {susAlmacenes.length === 0 ? <EstadoVacio mensaje="Esta sucursal no tiene almacenes" sugerencia="Agrega el primero con el botón «Agregar almacén»." data-id="element-1271" data-mp="3lagoq48dkr0e" /> : <ul className="grid gap-4 p-5 lg:grid-cols-2 xl:grid-cols-3" data-id="element-1272" data-mp="3v3xij88ii642">
            {susAlmacenes.map(a => {
          const estantes = a.pasillos.reduce((t, p) => t + p.estantes.length, 0);
          const cajas = contarCajas(a);
          const ocupados = expedientesEnAlmacen(a, expedientes);
          return <li key={a.id} className="rounded-lg border border-gris-200 px-4 py-3" data-id="element-1273" data-mp="30y2owtit162">
                  <div className="flex items-start justify-between gap-2" data-id="element-1274" data-mp="htroezzdydj6">
                    <div className="min-w-0" data-id="element-1275" data-mp="cxarbga7koty">
                      <p className="flex items-center gap-2 text-sm font-semibold text-marino-900" data-id="element-1276" data-mp="2jmxpubi95p9i">
                        <BoxesIcon className="h-4 w-4 text-gris-400" aria-hidden="true" data-id="element-1277" data-mp="2eoe4odbhghi7" />
                        {a.nombre}
                      </p>
                      <p className="mt-1 text-xs text-gris-600" data-id="element-1278" data-mp="u6lqc5qpue01">{a.descripcion}</p>
                    </div>
                    <button type="button" onClick={() => eliminarAlmacen(a.id)} aria-label={`Eliminar ${a.nombre}`} className="flex h-8 w-8 shrink-0 items-center justify-center rounded border border-transparent text-gris-400 transition-colors duration-150 hover:border-peligro-100 hover:text-peligro-600" data-id="element-1279" data-mp="z4df4qw2dk00">
                      <Trash2Icon className="h-4 w-4" data-id="element-1280" data-mp="feupntvhs9ux" />
                    </button>
                  </div>
                  <dl className="tabular mt-3 grid grid-cols-4 gap-2 border-t border-gris-100 pt-3 text-center" data-id="element-1281" data-mp="6ghn3zhfwg9k">
                    {[['Pasillos', a.pasillos.length], ['Estantes', estantes], ['Cajas', cajas], ['Exp.', ocupados]].map(([etiqueta, valor]) => <div key={etiqueta as string} data-id="element-1282" data-mp="1zeod1bu5kql9">
                        <dt className="text-2xs uppercase tracking-wide text-gris-400" data-id="element-1283" data-mp="1ue0m0q5xc9r1">
                          {etiqueta}
                        </dt>
                        <dd className="text-sm font-semibold text-marino-900" data-id="element-1284" data-mp="1ph9vta0enxrw">{valor}</dd>
                      </div>)}
                  </dl>
                </li>;
        })}
          </ul>}
      </Panel>

      <h2 className="mb-3 mt-6 text-sm font-semibold text-marino-900" data-id="element-1285" data-mp="2d4hyrlad2uqr">
        Mapa de almacén · agrega pasillos, estantes o cajas uno por uno
      </h2>

      <MapaAlmacen almacenes={mapa} piePasillo={almacenId => <button type="button" onClick={() => agregarPasillo(almacenId)} className={claseBotonPie} data-id="element-1287" data-mp="23eooqopvanom">
            <PlusIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1288" data-mp="30vnfe2o4lr24" />
            Agregar pasillo
          </button>} pieEstante={(almacenId, pasilloId) => <button type="button" onClick={() => agregarEstante(almacenId, pasilloId)} className={claseBotonPie} data-id="element-1289" data-mp="34dbdgezqxjj3">
            <PlusIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1290" data-mp="3dd7y85j0ly8v" />
            Agregar estante
          </button>} pieCaja={(almacenId, pasilloId, estanteId) => <button type="button" onClick={() => agregarCaja(almacenId, pasilloId, estanteId, capacidad)} className="inline-flex h-9 items-center gap-2 rounded border border-gris-200 px-3 text-xs font-semibold text-marino-700 transition-colors duration-150 hover:border-marino-300 hover:bg-marino-50" data-id="element-1291" data-mp="3i9olyymayalf">
            <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-1292" data-mp="4w3dxqv8nf0p" />
            Agregar caja (capacidad {capacidad})
          </button>} data-id="element-1286" data-mp="28byph0ipilrr" />
    </>;
}